<template>
    <div>
        <!--   Dynamic Field Modal     -->
        <div class="modal fade" id="dynamicFieldModal" tabindex="-1" role="dialog" aria-labelledby="Dynamic Field" aria-hidden="true" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Dynamic Field</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeFieldModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row w-100 p-0 m-0" v-if="fieldData.selectedType.name !== 'Checkbox'">
                            <div class="col-md-12 ml-0 pl-0">
                                Required field <b-form-checkbox id="field-required" v-model="fieldData.isRequired"/>
                            </div>
                        </div>
                        <div class="row w-100 p-0 m-0 mt-3">
                            <div class="col-md-6 ml-0 pl-0">
                                <div class="text-l w-100 p-0 m-0 mb-1">
                                    Field Type
                                </div>
                                <div class="w-100">
                                    <multiselect class="calender-filter"
                                                 v-model="fieldData.selectedType"
                                                 :options="fieldTypes"
                                                 placeholder="Select Field Type"
                                                 label="name"
                                                 track-by="name"
                                                 :multiple="false"
                                                 :close-on-select="true"
                                                 :clear-on-select="false"
                                                 :preserve-search="false"
                                                 :taggable="true"
                                                 open-direction="below"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-6 mr-0 pr-0">
                                <div class="text-l w-100 p-0 m-0 mb-1">
                                    <span class="align-left m-0 p-0">Name of field</span><span class="float-right field-info-icon" title="A short name to appear in the field list"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                                </div>
                                <div class="w-100">
                                    <input type="text" class="form-control w-100" v-model="fieldData.name">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 w-100 p-0 m-0 mt-3">
                            <div class="text-l w-100 p-0 m-0 mb-1">
                                <span class="align-left m-0 p-0">Label of field</span><span class="float-right field-info-icon" title="Label to show above the options"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                            </div>
                            <div class="w-100">
                                <input type="text" class="form-control w-100" v-model="fieldData.label">
                            </div>
                        </div>
                        <div class="row w-100 p-0 m-0 mt-3">
                            <div class="text-l w-100 p-0 m-0 mb-1">
                                <span class="align-left m-0 p-0">Options</span><span class="float-right field-info-icon" title="Options for checkbox, radio button and dropdown. Minimum 2 options required for radio button and 1 for dropdown/checkbox"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                            </div>
                            <div class="col-md-6 float-left mt-2" v-for="(fieldOption, index) in fieldData.options">
                                <div class="row p-0 m-0 mb-1" style="display: flex;align-items: baseline;">
                                    <div class="col-md-4 p-0 m-0 text-sm">Option {{index+1}}</div>
                                    <div class="col-md-8 p-0 m-0 text-right text-sm" v-if="fieldData.selectedType.name == 'Checkbox'">
                                        Required field <b-form-checkbox :id="'option-required-'+index" v-model="fieldOption.required"/>
                                    </div>
                                </div>
                                <input type="text" id class="form-control float-left" style="width: 80%" v-model="fieldOption.name">
                                <button class="form-control btn-danger float-right" style="width: 15%" @click="removeFieldOption(index)"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                            </div>
                            <div class="col-md-12 w-100">
                                <button @click="addFieldOption()" class="form-control btn-primary mt-4" style="width: 50%; margin:0 auto;"> Add Option </button>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button v-if="updateDynamicField" type="button" class="btn btn-danger" data-dismiss="modal" @click="deleteDynamicField()">Delete field</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeFieldModal">Close</button>
                        <button v-if="updateDynamicField" type="button" class="btn btn-primary" @click="updateDynamicFieldMethod()">Update field</button>
                        <button v-else type="button" class="btn btn-primary" @click="saveDynamicField()">Save field</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="createNewContactSignatureModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Add New Contact For Signature</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeCreateNewContactSignatureModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label>Contact Name</label>
                                <input type="text" class="form-control" v-model="newContactName">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label>Contact Email</label>
                                <input type="email" class="form-control" v-model="newContactEmail">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-inline-block text-right">
                        <span class="btn btn-outline-primary float-left d-flex align-items-center py-1 px-2" @click="openSelectContactModal()">
                            <i class="fa fa-user fa-2x mr-2"></i> Select Contact
                        </span>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeCreateNewContactSignatureModal">Close</button>
                        <button type="button" class="btn btn-primary" @click="createNewContact">Add Contact</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="openResourceImageAddModalRightSideBar" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Add Photos</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="w-1/4 mr-4 hidden lg:inline">
                            <file-pond
                                name="test"
                                ref="pondResourceImage"
                                label-idle="Drop multiple photos here or click to upload from your computer. <br><i class='fa fa-upload upload-icon-proposal'></i>"
                                allow-multiple="true"
                                :server="resourceServer"
                                :onprocessfile="handleOnProcessResourceFile"
                                :onaddfilestart="handleOnAddFileStart"
                                dropOnPage="false"
                                dropOnElement="true"
                                accepted-file-types="image/jpeg, image/png, image/jpg, image/webp"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" preview p-0 m-0 pg-right-sidebar-div">

            <div class="d-block w-100 float-left" style="padding: 0;margin-bottom: 20px;">
                <div>
                    <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">

                        <button @click="openResourceImageAddModalRightSideBar"
                                class="upload-btn-proposal" style="color:white;">Photos <i class="fa fa-upload upload-icon-proposal"></i>
                        </button>
                    </div>
                </div>

                <div class="col-md-12 overflow-scroll p-4" style="padding-left: 0 !important; padding-right: 0 !important; max-height: 32vh;">
                    <div v-for="resourceImage in resourceFiles" >
                        <div @mouseover="showResourceDeleteButton(resourceImage.id)" @mouseleave="hideResourceDeleteButton(resourceImage.id)" class="col-md-6 resource-images-div">
                            <div class="delete-resource-file-button" :id="'resource-delete-'+resourceImage.id" title="Delete" @click="deleteResourceFile(resourceImage)">x</div>
                            <div class="resource-images">
                                <img v-if="section.tag != 'title' && !section.type_photo" width="500" style="max-width:100%" @click="addImageToCKeditor(resourceImage.url, resourceImage.id)" :src="(resourceImage.pg_thumbnail)? resourceImage.pg_thumbnail:resourceImage.url" class="lazyload">
                                <img v-else-if="section.tag == 'title' && !section.type_photo" width="500" style="max-width:100%" @click="selectCoverImage(resourceImage.url, resourceImage.id)" :src="(resourceImage.pg_thumbnail)? resourceImage.pg_thumbnail:resourceImage.url" class="lazyload">
                                <img v-else width="500" style="max-width:100%" @click="selectPhotoPageImage(resourceImage)" :src="(resourceImage.pg_thumbnail)? resourceImage.pg_thumbnail:resourceImage.url" class="lazyload">
                            </div>
                            <span class="resource-images-name">{{resourceImage.name}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block w-100 float-left" style="padding: 0;margin-bottom: 20px;">
                <div>
                    <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">

                        <div class="" style="color:white;">
                            Signatures
                        </div>
                    </div>
                </div>

                <div class="col-md-12 p-4 signature-field-div" style="padding-left: 0 !important; padding-right: 0 !important; max-height: 52vh;">
                    <multiselect :options="signatureUsers"
                                 placeholder="Add Signature"
                                 v-model="selectedSignatureUser"
                                 :show-labels="false"
                                 class="mb-2 cursor-pointer"
                                 :multiple="false"
                                 :close-on-select="true"
                                 :clear-on-select="false"
                                 :preserve-search="false"
                                 :taggable="false"
                                 open-direction="below"
                                 label="displayName"
                                 track-by="id"
                                 :preselect-first="false"
                                 group-values="contact_options"
                                 group-label="contact_type"
                                 :group-select="false"
                    >
                    </multiselect>
                </div>
                <div class="col-md-12 overflow-hidden" style="padding-left: 0 !important; padding-right: 0 !important;" v-if="allSignerFields.length > 0" v-for="(signerField, index) in allSignerFields">
                    <div @click="toolButton(slugify(signerField.name)+'_signature', signerField.name+' Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">{{signerField.name+' Signature'}}</div>
                    <div @click="toolButton(slugify(signerField.name)+'_initials', signerField.name+' Initials')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">{{signerField.name+' Initials'}}</div>
                </div>
            </div>

            <div class="d-block w-100 float-left" style="padding: 0;margin-bottom: 20px;">
                <div>
                    <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">

                        <button
                            class="" style="color:white;">Fields
                        </button>
                    </div>
                </div>
                <div class="col-md-12 p-3" style="padding-left: 0 !important; padding-right: 0 !important;">
                    <div @click="toolButton('accountManager', 'Account Manager')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.accountManager">Account Manager</div>
                    <div @click="toolButton('baseBid', 'Base Bid')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.baseBid">Base Bid</div>
                    <div @click="toolButton('companyAddress', 'Company Address')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.companyAddress">Company Address</div>
                    <div @click="toolButton('companyCity', 'Company City')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.companyCity">Company City</div>
                    <div @click="toolButton('contactCompany', 'Company Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.contactCompany">Company Name</div>
                    <div @click="toolButton('companyNumber', 'Company Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.companyNumber">Company Number</div>
                    <div @click="toolButton('companyState', 'Company State')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.companyState">Company State</div>
                    <div @click="toolButton('companyZip', 'Company Zip')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.companyZip">Company Zip</div>
                    <div @click="toolButton('contactEmail', 'Contact Email')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.contactEmail">Contact Email</div>
                   <div @click="toolButton('addInitials', 'Contact Initials')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.addInitials">Contact Initials</div>
                    <div @click="toolButton('contactName', 'Contact Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.contactName">Contact Name</div>
                    <div @click="toolButton('contactNumber', 'Contact Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.contactNumber">Contact Number</div>
                   <div @click="toolButton('addSignature', 'Contact Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.addSignature">Contact Signature</div>
                    <div @click="toolButton('contactTitle', 'Contact Title')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.contactTitle">Contact Title</div>
                    <div @click="toolButton('estimator', 'Estimator')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.estimator">Estimator</div>
                    <div @click="toolButton('myEmail', 'My Email')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.myEmail">My Email</div>
                    <div @click="toolButton('myName', 'My Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.myName">My Name</div>
                    <div @click="toolButton('myNumber', 'My Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.myNumber">My Number</div>
                   <div @click="toolButton('mySignature', 'My Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.mySignature">My Signature</div>
                    <div @click="toolButton('myTitle', 'My Title')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.myTitle">My Title</div>
                    <div @click="toolButton('projectAddress', 'Project Address')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.projectAddress">Project Address</div>
                    <div @click="toolButton('city', 'Project City')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.city">Project City</div>
                    <div @click="toolButton('projectID', 'Project ID')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.projectID">Project ID</div>
                    <div @click="toolButton('projectName', 'Project Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.projectName">Project Name</div>
                    <div @click="toolButton('state', 'Project State')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.state">Project State</div>
                    <div @click="toolButton('zipCode', 'Project Zip Code')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.zipCode">Project Zip Code</div>
                    <div @click="toolButton('addDate', 'Signature Date')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.addDate">Signature Date</div>
                    <div @click="toolButton('state', 'Take Off Person')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.takeOffPerson">Take off person</div>
                    <div @click="toolButton('todayDate', 'Todays Date')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="proposal.field_data.todayDate">Todays Date</div>
                </div>
            </div>
            <div class="d-block w-100 float-left" style="padding: 0;margin-bottom: 20px;">
                <div>
                    <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">
                        <button
                            class="" style="color:white;">Custom Fields
                        </button>
                    </div>
                </div>
                <div class="col-md-12 p-3" style="padding-left: 0 !important; padding-right: 0 !important;">
                    <span v-if="customFieldsLables.length > 0">
                        <div v-for="customFieldsLable in customFieldsLables" v-if="customFieldsLable.enabled" @click="toolButton(customFieldsLable.label_value.replace(/\s+/g, '-').toLowerCase(), customFieldsLable.name)" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top" :title="(customFieldsLable.field_value && customFieldsLable.field_value !== '')? (customFieldsLable.type == 4)? formatDate(customFieldsLable.field_value):customFieldsLable.field_value:'N/A'">{{ customFieldsLable.name }}</div>
                    </span>
                </div>
            </div>
            <div class="d-block w-100 float-left" style="padding: 0;margin-bottom: 20px;">
                <div>
                    <div v-if="role || user.id == proposal.created_by_id" class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">
                        <button @click="addDynamicFieldModal"
                            class="" style="color:white;">Dynamic Fields
                        </button>
                        <button @click="addDynamicFieldModal"
                            class="" style="color:white;float:right;padding-top:3px;">+
                        </button>
                    </div>
                    <div v-else class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">
                        <button class="" style="color:white;">Dynamic Fields
                        </button>
                        <button class="" style="color:white;float:right;padding-top:3px;">+
                        </button>
                    </div>
                </div>
                <div class="col-md-12 p-3" style="padding-left: 0 !important; padding-right: 0 !important;">
                    <span v-if="dynamicFields.length > 0">
                        <div v-for="dynamicField in dynamicFields"  class="field-tooltip col-md-12 inline-block float-left dynamic-field-div" data-toggle="tooltip" data-placement="top"><span class="text-left col-md-8 m-0 p-0 dynamic-field-name" @click="toolButtonDynamicField(dynamicField.name.replace(/\s+/g, '-').toLowerCase(), dynamicField.code)">{{ dynamicField.name }}</span><span v-if="role || user.id == proposal.created_by_id" class="col-md-4 m-0 p-0 dynamic-field-edit " @click="editDynamicField(dynamicField)"><i class="fa fa-cog" aria-hidden="true"></i></span></div>
                    </span>
                </div>
            </div>
        </div>

        <div class="modal" id="selectContactModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12" style="text-align: center; font-size:20px; margin-top: 10px;">Select a Contact</div>
                            <div class="col-md-12" style="text-align: center; margin-top: 32px;">
                                <button type="button" class="btn btn-primary" style="padding: 20px;margin-right: 12px;"
                                        @click="openNewCompanyContactModal"> Company Contact</button>
                                <button type="button" class="btn btn-primary" style="padding: 20px;"
                                        @click="openEmailContactModal">Email Contact</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <company-contact-modal
            ref="CompanyContactModal"
            :masks="this.masks"
            :symbols="this.symbols"
            @selected="parseContacts"
        ></company-contact-modal>

        <project-contact-modal
            ref="EmailContactModal"
            :masks="masks"
            :symbols="symbols"
            :exchange="exchange"
            :externalEmailService="externalEmailService"
            @selected="parseContacts"
        ></project-contact-modal>
    </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
const FilePond = vueFilePond(FilePondPluginFileValidateType);
import axios from "axios";
import Multiselect    from 'vue-multiselect';
let token = document.head.querySelector('meta[name="csrf-token"]');
import Swal from "sweetalert2";
import CompanyContactModal from "../company/company-contact-modal.vue";
import ProjectContactModal from "../project/external-email/project-contact-modal.vue";
export default {
    props: ['section', 'proposal', 'role', 'user', 'team', 'activeTeamUsers', 'masks', 'symbols', 'exchange', 'externalEmailService', 'project'],
    components: {ProjectContactModal, CompanyContactModal, FilePond,Multiselect},
    name: "proposal-right-sidebar",
    data(){
        return {
            resourceFiles: [],
            revertedResources: [],
            data_loading: false,
            hasOneFile: false,
            signatureButton: false,
            tempSection: {
                id: this.section.id,
            },
            server: {
                revert: (uniqueFileId, load, error) => {
                    let file = JSON.parse(uniqueFileId).section;
                    axios.delete(route('proposal.delete-file-custom-section', {
                        proposal: this.proposal.id,
                        token: file.token,
                    }))
                        .catch((err) => error(err.response.message));
                    load();
                },
                process: (fieldName, file, metadata, load, error, progress) => {
                    const formData = new FormData();
                    formData.append('file', file, file.name);

                    const request = new XMLHttpRequest();
                    request.open('POST', '/proposal/' + this.proposal.id + '/proposal-custom-section/' + this.tempSection.id + '/upload-file');
                    request.setRequestHeader('X-CSRF-TOKEN', token.content);

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                        } else {
                            error('oh no');
                        }
                    };
                    request.send(formData);
                }
            },
            resourceServer: {
                revert: (uniqueFileId, load, error) => {
                    let file = JSON.parse(uniqueFileId).resource;
                    this.revertedResources.push(file.token);
                    axios.delete(route('api.resource-files.destroy', {resourceFile: file.token}))
                        .catch((err) => error(err.response.message));
                    load();
                },
                process: (fieldName, file, metadata, load, error, progress) => {
                    const formData = new FormData();
                    // if (this.section.company) formData.append('company_id', this.section.company.id);
                    if (this.proposal.project_id) formData.append('project_id', this.proposal.project_id);
                    if (2) formData.append('directory_id', 2);
                    formData.append(fieldName, file, file.name);

                    const request = new XMLHttpRequest();
                    request.open('POST', '/api/proposal-resource-files');
                    request.setRequestHeader('X-CSRF-TOKEN', token.content);

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                        } else {
                            error('oh no');
                        }
                    };

                    request.send(formData);
                    request.response = function (){
                        this.fetchData();
                        $("#openResourceImageAddModal").modal("hide");
                    }
                    setTimeout(function(){
                        $("#openResourceImageAddModal").modal("hide");
                    }, 3000);
                }
            },
            customFieldsLables:[],
            fieldTypes:[
                {
                    "name":"Checkbox"
                },{
                    "name":"Radio"
                },{
                    "name":"Dropdown"
                }
            ],
            fieldData: {
                isRequired: true,
                selectedType: { name: null},
                name: '',
                label: '',
                title: '',
                options: [
                    {
                        name: '',
                        required: false
                    },
                    {
                        name: '',
                        required: false
                    }
                ]
            },
            dynamicFields: [],
            updateDynamicField: false,
            updateDynamicFieldId: null,
            signatureUsers: [],
            selectedSignatureUser: null,
            newContactName: null,
            newContactEmail: null,
            allSignerFields: []
        }
    },
    created() {
        this.fetchData();
    },
    mounted() {
        Bus.$on('fetchLatestResourceFile', data => {
            this.fireSuccessToast('Resource file deleted.');
            this.fetchData();
        });
        Bus.$on('refreshResourcesSideBar', data => {
            this.fetchData();
        });

        $(function () {
            $(".field-tooltip").tooltip();
        });

        this.fetchProjectCustomFields();

        Bus.$on('fetchResourcesFromPhotoTemplate', data => {
            this.fetchData();
        });

        this.getDynamicFields();
        this.getContactsDataForSignature();
        this.getAllSignerFields();

        Bus.$on('openEmailContactModalParent', data => {
            $('#modal-contact').modal('hide');
            this.$refs.CompanyContactModal.close();
            this.$refs.EmailContactModal.open(this.project.id, 'forProposal');

        });

        Bus.$on('openCompanyContactModal', data => {
            this.$refs.EmailContactModal.close();
            this.$refs.CompanyContactModal.open('forProposal');

        });

    },
    methods: {
        toolButton(button, text){
            var data = [];
            data['button'] = button;
            data['text'] = text;
            Bus.$emit('toolButton', data);
        },
        handleOnProcessResourceFile(error, resourceFile) {
            setTimeout(() => {
                this.$refs.pondResourceImage.removeFile(resourceFile.id);
                if (!resourceFile.serverId) return;
                let file = JSON.parse(resourceFile.serverId).resource;
                if (this.revertedResources.includes(file.token)) return;
                file.thumb_url = route('resource-files.show-thumb', {resourceFile: file.token});
                file.id_key = file.id;
                this.resourceFiles.push(file);
                this.hasOneFile = this.resourceFiles.length > 0;
            }, 2000);
        },
        handleOnAddFileStart() {
            this.hasOneFile = true;

        },
        async uploadFile() {
            let files = this.$refs.responsiveFileInput.files;
            if (files) {
                let i = 0;
                for (i; i < files.length; i++) {
                    const formData = new FormData();

                    // if (this.section.company) formData.append('company_id', this.section.company.id);
                    if (this.proposal.project_id) formData.append('project_id', this.proposal.project_id);
                    if (2)  formData.append('directory_id', 2)
                    formData.append('test', files[i]);
                    await axios.post('/api/resource-files', formData).catch(err => {
                        window.Swal.fire({
                            title: "An error occurred!",
                            text: "The file could not be uploaded!",
                            buttons: true,
                        });
                    });
                }
                window.location.reload();
            }
        },
        openResourceImageAddModalRightSideBar() {
            $("#openResourceImageAddModalRightSideBar").modal("show");
        },
        fetchData() {
            let params = {
                // company_id: this.section.company.id,
                project_id: this.proposal.project_id,
                folder_id: 2,
            };

            this.data_loading = true;
            axios.get(route('api.proposal-resource-files.index'), {params}).then(({data}) => {
                this.resourceFiles = data.data.map(resourceFile => {
                    resourceFile.thumb_url = route('resource-files.show-thumb', {resourceFile: resourceFile.token});
                    resourceFile.is_thumb_loaded = false;
                    resourceFile.id_key = resourceFile.id;
                    return resourceFile;
                });
                this.hasOneFile = this.resourceFiles.length > 0;
                this.pagination = data;
                this.data_loading = false;
            });
        },
        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Toast.fire({
                type: 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Toast.fire({
                type: 'error',
                title: message,
            });
        },
        handleOnProcessFile() {
            this.saveCustomSection();
        },
        showResourceDeleteButton(id){
            var myElement = document.getElementById('resource-delete-'+id);
            myElement.style.setProperty('display','block', 'important');
        },
        hideResourceDeleteButton(id){
            var myElement = document.getElementById('resource-delete-'+id);
            myElement.style.setProperty('display','none', 'important');
        },
        deleteResourceFile(resourceFile){
            Bus.$emit('delResourceFile', resourceFile);
        },
        selectCoverImage(thumbnail, id){

            axios.get('/proposal/'+this.proposal.id+'/proposal-generator/select-resource-file/'+id).then(({data}) => {
                if(data.status == 'success'){
                    Bus.$emit('selectCoverImage', thumbnail);
                    Bus.$emit('changeCoverImage', true);
                    Bus.$emit('selectCoverPageTemplateChild', id);
                    this.fireSuccessToast(data.message);
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        addImageToCKeditor(thumbnail, id){
            // for (var i in CKEDITOR.instances) {
            //     var img = new Image();
            //     img.src = thumbnail;
            //     img.onload = function() {
            //         if(this.width > 500 && this.height < 1100){
            //             var data = '<span class="easyimage cke_widget_element easyimage-full"><img width="500" height="auto" style="max-width:100%" src="' + thumbnail + '" /></span>';
            //             CKEDITOR.instances[i].insertHtml(data, 'unfiltered_html');
            //         }else if(this.height > 1100){
            //             var data = '<span class="easyimage cke_widget_element easyimage-full"><img width="auto" height="770" style="max-width:100%" src="' + thumbnail + '" /></span>';
            //             CKEDITOR.instances[i].insertHtml(data, 'unfiltered_html');
            //         }else{
            //             var data = '<span class="easyimage cke_widget_element easyimage-full"><img width="500" height="auto" style="max-width:100%" src="' + thumbnail + '" /></span>';
            //             CKEDITOR.instances[i].insertHtml(data, 'unfiltered_html');
            //         }
            //     }
            //
            // }
            Bus.$emit('insertImageToPrizmEditor', thumbnail);
        },
        fetchProjectCustomFields(){
            this.labelsReorder = [];
            this.customLabelsReorder = [];
            axios.get(route('api.project-custom-field.proposal-generator', {project:this.proposal.project_id}))
                .then((response) => {
                    this.customFieldsLables = [];
                    this.customFieldsLables = response.data.sort((a,b) => a.label_order - b.label_order);
                });
        },
        formatDate(dateValue){
            return moment.utc(dateValue).local().format('MM/DD/YYYY')
        },
        selectPhotoPageImage(resourceImage){
            Bus.$emit('emitPhotoForPhotoPage', resourceImage);
        },
        addDynamicFieldModal(){
            $('#dynamicFieldModal').modal('show');
            $('.field-info-icon').tooltip();
        },
        addFieldOption(){
            let option = {
                name: '',
                required: false
            }
            this.fieldData.options.push(option);
        },
        removeFieldOption(index){
            this.fieldData.options.splice(index, 1);
        },
        closeFieldModal(){
            $('#dynamicFieldModal').modal('hide');
            let fieldData = {
                isRequired: true,
                selectedType: { name: null},
                name: '',
                label: '',
                title: '',
                options: [
                    {
                        name: '',
                        required: false
                    },
                    {
                        name: '',
                        required: false
                    }
                ]
            };
            this.fieldData = fieldData;
            this.updateDynamicField = false;
            this.updateDynamicFieldId = null;
        },
        saveDynamicField(){
            if(this.fieldData.selectedType){
                let numberOfOption = 0;
                if(this.fieldData.selectedType.name == 'Radio'){
                    numberOfOption = 2;
                }else{
                    numberOfOption = 1;
                }

                if(this.fieldData.options.length >= numberOfOption){
                    var optionData = false;
                    this.fieldData.options.forEach((item, index) => {
                        if(!item.name || item.name.trim() == ''){
                            let optionNo = index+1;
                            this.getToast().fire({
                                type: 'error',
                                title: 'Please add value to option '+optionNo
                            });
                            optionData = true;
                            return false;
                        }

                    });
                    if(optionData){
                        return false;
                    }
                }else{
                    if(this.fieldData.selectedType.name == 'Radio'){
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 2 options.'
                        });
                        return false;
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 1 option.'
                        });
                        return false;
                    }
                }

                if(!this.fieldData.name || this.fieldData.name == '' || !this.fieldData.label || this.fieldData.label == ''){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please enter field name'
                    });
                    return false;
                }
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select field type'
                });
                return false;
            }

            axios.post(route('proposal-generator.crate-dynamic-field'), {data: this.fieldData}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.closeFieldModal();
                this.getDynamicFields();
            });
        },
        getDynamicFields(){
            axios.post(route('proposal-generator.get-dynamic-field'), {data: this.fieldData}).then(response => {
                console.log(response);
                this.dynamicFields = response.data.dynamicFields
            });
        },
        editDynamicField(dynamicField){
            this.updateDynamicField = true;
            this.updateDynamicFieldId = dynamicField.id;
            let fieldData = {
                isRequired: (dynamicField.is_required == 1)? true:false,
                selectedType: { name: dynamicField.type },
                name: dynamicField.name,
                label: dynamicField.label,
                options: dynamicField.proposal_generator_dynamic_field_values
            };
            this.fieldData = fieldData;
            this.addDynamicFieldModal();
        },
        deleteDynamicField(){
            axios.post(route('proposal-generator.delete-dynamic-field'), {fieldId: this.updateDynamicFieldId}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: 'Field deleted successfully'
                });
                this.getDynamicFields();
            });
        },
        updateDynamicFieldMethod(){
            if(this.fieldData.selectedType){
                let numberOfOption = 0;
                if(this.fieldData.selectedType.name == 'Radio'){
                    numberOfOption = 2;
                }else{
                    numberOfOption = 1;
                }

                if(this.fieldData.options.length >= numberOfOption){
                    var optionData = false;
                    this.fieldData.options.forEach((item, index) => {
                        if(!item.name || item.name.trim() == ''){
                            let optionNo = index+1;
                            this.getToast().fire({
                                type: 'error',
                                title: 'Please add value to option '+optionNo
                            });
                            optionData = true;
                            return false;
                        }

                    });
                    if(optionData){
                        return false;
                    }
                }else{
                    if(this.fieldData.selectedType.name == 'Radio'){
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 2 options.'
                        });
                        return false;
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 1 option.'
                        });
                        return false;
                    }
                }

                if(!this.fieldData.name || this.fieldData.name == '' || !this.fieldData.label || this.fieldData.label == ''){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please enter field name'
                    });
                    return false;
                }
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select field type'
                });
                return false;
            }

            axios.post(route('proposal-generator.update-dynamic-field'), {data: this.fieldData, fieldId: this.updateDynamicFieldId}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.closeFieldModal();
                this.getDynamicFields();
            });
        },
        toolButtonDynamicField(button, text){
            var data = [];
            data['button'] = button;
            data['text'] = text;
            Bus.$emit('toolButtonDynamicField', data);
        },
        getContactsDataForSignature(){
            axios.post(route('proposal-generator.get-contact-information'), {projectId: this.proposal.project_id, teamId: this.team.id}).then(response => {
                console.log(response);
                let contactArray = [];
                if(response.data.projectContact){
                    if(response.data.projectContact.email && response.data.projectContact.email !== ''){
                        let projectContact  = {
                            contact_type: 'Project Contact',
                            contact_options: [
                                {...response.data.projectContact, type: 'project_contact', displayName: response.data.projectContact.name},
                            ]
                        };
                        contactArray.push(projectContact);
                    }
                }

                if(response.data.companyContacts.length > 0){
                    let companyContactOptions = [];
                    response.data.companyContacts.forEach(item => {
                        if(item.email && item.email !== ''){
                            companyContactOptions.push({...item, type: 'company_contact', displayName: item.name+' ('+item.company_name+')'});
                        }
                    });
                    let companyContact  = {
                        contact_type: 'Company Contact',
                        contact_options: companyContactOptions
                    };
                    contactArray.push(companyContact);
                }

                if(this.activeTeamUsers.length > 0){
                    let teamUserOptionsOptions = [];
                    this.activeTeamUsers.forEach(item => {
                        if(item.email && item.email !== ''){
                            teamUserOptionsOptions.push({...item, type: 'team_users', displayName: item.name});
                        }
                    });
                    let teamUser  = {
                        contact_type: 'Team Users',
                        contact_options: teamUserOptionsOptions
                    };
                    contactArray.push(teamUser);
                }

                let newContactOption = [];
                let item = {
                    id: 0,
                    name:'New Contact'
                };
                newContactOption.push({...item, type: 'new_contact', displayName: '+ NEW CONTACT'});

                let newContact  = {
                    contact_type: 'New Contact',
                    contact_options: newContactOption
                };
                contactArray.push(newContact);

                this.signatureUsers = contactArray;
            });
        },
        createNewContact(){
            if(this.newContactName === '' || this.newContactName == null || this.newContactName.trim() == ''){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please add contact name'
                });
                this.newContactName = null;
                this.newContactEmail = null;
                return false;
            }

            if(this.newContactEmail === '' || this.newContactEmail == null || this.newContactEmail.trim() === '' || !this.isValidEmail(this.newContactEmail)){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please add valid email address'
                });
                this.newContactName = null;
                this.newContactEmail = null;
                return false;
            }
            let contactData = {
                name: this.newContactName,
                email: this.newContactEmail,
            };
            axios.post(route('proposal-generator.save-new-contact-signature-field'), {proposalId: this.proposal.id, selectedUser: this.selectedSignatureUser, contactData: contactData}).then(response => {
                this.allSignerFields = response.data.allFields;
                this.closeCreateNewContactSignatureModal();
                this.newContactName = null;
                this.newContactEmail = null;
                this.selectedSignatureUser = null;
                this.$refs.CompanyContactModal.close();
                this.$refs.EmailContactModal.close();
                Bus.$emit('allCustomSignatures1', response.data.allFields);
            });

        },
        createSignatureField(){
            let contactData = {
                name: this.newContactName,
                email: this.newContactEmail,
            };
            axios.post(route('proposal-generator.save-new-contact-signature-field'), {proposalId: this.proposal.id, selectedUser: this.selectedSignatureUser, contactData: contactData}).then(response => {
                if(response.data.status == 'success'){
                    this.allSignerFields = response.data.allFields;
                    this.closeCreateNewContactSignatureModal();
                    this.newContactName = null;
                    this.newContactEmail = null;
                    this.selectedSignatureUser = null;
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: 'Signer already listed'
                    });
                    this.newContactName = null;
                    this.newContactEmail = null;
                    this.selectedSignatureUser = null;
                }
            });
        },
        closeCreateNewContactSignatureModal(){
            $('#createNewContactSignatureModal').modal('hide');
        },
        openCreateNewContactSignatureModal(){
            $('#createNewContactSignatureModal').modal('show');
        },
        isValidEmail(email) {
            // Regular expression pattern for a valid email address
            var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            return pattern.test(email);
        },
        slugify(text) {
            return text
                .toString()
                .toLowerCase()
                .trim()
                .replace(/\s+/g, '_') // Replace spaces with hyphens
                .replace(/&/g, '_and_') // Replace & with 'and'
                .replace(/[^\w-]+/g, '') // Remove non-word characters except hyphens
                .replace(/--+/g, '_'); // Replace multiple hyphens with a single hyphen
        },
        getAllSignerFields(){
            axios.post(route('proposal-generator.get-all-signature-fields'), {proposalId: this.proposal.id, fromWhere: 'pg'}).then(response => {
                this.allSignerFields = response.data.allFields;
                Bus.$emit('allCustomSignatures1', response.data.allFields);
            });
        },
        openSelectContactModal() {
            $('#createNewContactSignatureModal').modal('hide');
            $('#selectContactModal').modal('show');
        },
        openNewCompanyContactModal(){
            $('#selectContactModal').modal('hide');
            this.$refs.CompanyContactModal.open('forProposal');
        },
        openEmailContactModal(){
            $('#selectContactModal').modal('hide');
            this.$refs.EmailContactModal.open(this.project.id, 'forProposal');
        },
        parseContacts(contact) {
            this.newContactName = contact.name;
            this.newContactEmail = contact.email;
            this.$nextTick(() => {
                this.createNewContact();
            });
        },
    },
    watch:{
        selectedSignatureUser(val){
           if(val && val.id == 0){
               this.openCreateNewContactSignatureModal();
           }else if(val && val.id != 0){
                this.createSignatureField();
           }
        }
    },
}
</script>

<style scoped>
.resource-images-div {
    float: left;
    padding: 0 5px;
    margin-bottom: 10px;
    height: 100px;
    overflow:hidden;
}
.resource-images-div img{
    height:60px;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}
span.resource-images-name {
    font-size: 10px;
    word-break: break-word;
}
.resource-images {
    height: 55px;
}
.resource-images:hover {
    cursor: pointer;
}
.upload-icon-proposal {
    font-size: 18px;
    margin-left: 6px;
}
.upload-btn-proposal:hover{
    border: 1px solid #fff;
    padding: 0 10px;
    border-radius: 5px;
    background: #fff;
    color: #01b1af !important;
}
.upload-btn-proposal{
    border: 1px solid #fff;
    padding: 0 10px;
    border-radius: 5px;
    background: #01b1af;
    color: #fff !important;
    cursor: pointer;
}
.tool-buttons {
    border: 1px solid #01b1af;
    margin: 0 5px;
    font-size: 12px;
    padding: 10px 0;
    color: #01b1af;
    text-align: center;
    margin-bottom: 9px;
    max-width: 93% !important;
    margin-right: 5px;
    margin-left: 7px;
}
.tool-buttons:hover {
    background-color: #01b1af1c;
    cursor: pointer;
}
.signature-field-div::-webkit-scrollbar{
    display: none;
}



.pg-right-sidebar-div .col-xl,
.pg-right-sidebar-div .col-xl-auto,
.pg-right-sidebar-div .col-xl-12,
.pg-right-sidebar-div .col-xl-11,
.pg-right-sidebar-div .col-xl-10,
.pg-right-sidebar-div .col-xl-9,
.pg-right-sidebar-div .col-xl-8,
.pg-right-sidebar-div .col-xl-7,
.pg-right-sidebar-div .col-xl-6,
.pg-right-sidebar-div .col-xl-5,
.pg-right-sidebar-div .col-xl-4,
.pg-right-sidebar-div .col-xl-3,
.pg-right-sidebar-div .col-xl-2,
.pg-right-sidebar-div .col-xl-1,
.pg-right-sidebar-div .col-lg,
.pg-right-sidebar-div .col-lg-auto,
.pg-right-sidebar-div .col-lg-12,
.pg-right-sidebar-div .col-lg-11,
.pg-right-sidebar-div .col-lg-10,
.pg-right-sidebar-div .col-lg-9,
.pg-right-sidebar-div .col-lg-8,
.pg-right-sidebar-div .col-lg-7,
.pg-right-sidebar-div .col-lg-6,
.pg-right-sidebar-div .col-lg-5,
.pg-right-sidebar-div .col-lg-4,
.pg-right-sidebar-div .col-lg-3,
.pg-right-sidebar-div .col-lg-2,
.pg-right-sidebar-div .col-lg-1,
.pg-right-sidebar-div .col-md,
.pg-right-sidebar-div .col-md-auto,
.pg-right-sidebar-div .col-md-12,
.pg-right-sidebar-div .col-md-11,
.pg-right-sidebar-div .col-md-10,
.pg-right-sidebar-div .col-md-9,
.pg-right-sidebar-div .col-md-8,
.pg-right-sidebar-div .col-md-7,
.pg-right-sidebar-div .col-md-6,
.pg-right-sidebar-div .col-md-5,
.pg-right-sidebar-div .col-md-4,
.pg-right-sidebar-div .col-md-3,
.pg-right-sidebar-div .col-md-2,
.pg-right-sidebar-div .col-md-1,
.pg-right-sidebar-div .col-sm,
.pg-right-sidebar-div .col-sm-auto,
.pg-right-sidebar-div .col-sm-12,
.pg-right-sidebar-div .col-sm-11,
.pg-right-sidebar-div .col-sm-10,
.pg-right-sidebar-div .col-sm-9,
.pg-right-sidebar-div .col-sm-8,
.pg-right-sidebar-div .col-sm-7,
.pg-right-sidebar-div .col-sm-6,
.pg-right-sidebar-div .col-sm-5,
.pg-right-sidebar-div .col-sm-4,
.pg-right-sidebar-div .col-sm-3,
.pg-right-sidebar-div .col-sm-2,
.pg-right-sidebar-div .col-sm-1,
.pg-right-sidebar-div .col,
.pg-right-sidebar-div .col-auto,
.pg-right-sidebar-div .col-12,
.pg-right-sidebar-div .col-11,
.pg-right-sidebar-div .col-10,
.pg-right-sidebar-div .col-9,
.pg-right-sidebar-div .col-8,
.pg-right-sidebar-div .col-7,
.pg-right-sidebar-div .col-6,
.pg-right-sidebar-div .col-5,
.pg-right-sidebar-div .col-4,
.pg-right-sidebar-div .col-3,
.pg-right-sidebar-div .col-2,
.pg-right-sidebar-div .col-1 {
    position: unset !important;
}


</style>
<style>
.delete-resource-file-button {
    width: 20px;
    height: 20px;
    font-size: 12px;
    background: red;
    text-align: center;
    color: white;
    position: absolute;
    top: 0px;
    z-index: 999;
    display: none;
    cursor: pointer;
}
.field-info-icon{
    color: #01b1af;
}
.dynamic-field-div{
    border: 1px solid #01b1af;
    margin: 0 5px;
    font-size: 12px;
    color: #01b1af;
    max-width: 93% !important;
    text-align: center;
    margin-bottom: 9px;
    margin-right: 5px;
    margin-left: 7px;
    padding-right: 0;
    cursor: pointer;
    overflow: hidden;
    display: flex;
}
.dynamic-field-name {
    float: left;
    display: flex;
    align-items: center;
    height: 100%;
    word-wrap: break-word;
    padding: 15px 0 !important;
    overflow: hidden;
}
.dynamic-field-edit {
    float: right;
    font-size: 17px;
    justify-content: center;
    color: white;
    background: #01b1af;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.dynamic-field-div:hover {
    background-color: #01b1af1c;
    cursor: pointer;
}

</style>
